import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import api from '../../api/axios'
import Message from '../../components/Message'
import Loader from '../../components/Loader'

function ResetPassword() {
  const { token } = useParams()
  const navigate = useNavigate()

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [tokenValid, setTokenValid] = useState(true)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (!token) {
      setTokenValid(false)
      setError('Token nie został dostarczony')
    }
  }, [token])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)

    if (password !== confirmPassword) {
      setError('Hasła nie są identyczne')
      return
    }

    if (password.length < 8) {
      setError('Hasło musi mieć co najmniej 8 znaków')
      return
    }

    setLoading(true)

    try {
      await api.post('/users/password-reset/confirm/', {
        token,
        password
      })
      setSuccess(true)

      // Redirect to login after 2 seconds
      setTimeout(() => {
        navigate('/login')
      }, 2000)
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Błąd resetowania hasła'
      setError(errorMessage)

      if (errorMessage.includes('wygasł') || errorMessage.includes('Nieprawidłowy')) {
        setTokenValid(false)
      }
    } finally {
      setLoading(false)
    }
  }

  if (!tokenValid) {
    return (
      <div className="pub-form-box">
        <h1 className="pub-h2">Link wygasł lub jest nieprawidłowy</h1>
        <p className="pub-muted" style={{ marginBottom: 28 }}>{error}</p>
        <Link to="/forgot-password" className="pub-btn">Poproś o nowy link</Link>
      </div>
    )
  }

  return (
    <div className="pub-form-box">
      <h1 className="pub-h2">Ustaw nowe hasło</h1>
      <p className="pub-muted" style={{ marginBottom: 28 }}>Wpisz nowe hasło do konta SIGMA.</p>

      <div className="pub-card">
        {success ? (
          <div>
            <h2 className="pub-h3">Hasło zmienione</h2>
            <p className="pub-muted">Za chwilę przeniesiemy Cię na stronę logowania.</p>
          </div>
        ) : (
          <>
            {error && <Message variant='danger'>{error}</Message>}
            {loading && <Loader />}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="reset-password">
                <Form.Label>Nowe hasło</Form.Label>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder='Wpisz nowe hasło'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
                <Form.Text className="pub-small">Minimum 8 znaków.</Form.Text>
              </Form.Group>

              <Form.Group className="mb-3" controlId="reset-confirm">
                <Form.Label>Potwierdź hasło</Form.Label>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder='Powtórz hasło'
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  disabled={loading}
                />
              </Form.Group>

              <Form.Check
                className="mb-4"
                type="checkbox"
                id="reset-show"
                label="Pokaż hasło"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
              />

              <button type="submit" className="pub-btn w-100" disabled={loading}>
                {loading ? 'Zmiana hasła…' : 'Zmień hasło'}
              </button>
            </Form>
          </>
        )}
      </div>
    </div>
  )
}

export default ResetPassword
